export const initUser = {
  info: null,
  loading: false,
  error: false,
}